package com.xtream.`data-kmp`

import kotlin.OptIn
import kotlin.String
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport

@JsExport
@OptIn(ExperimentalJsExport::class)
public actual object DataBuildKonfig {
  public actual val VERSION_NAME: String = "4.29"
}
